import {dimensions,borderStyle,boxShadow,borderRadiusStyle,
	VayuBlocksTypography,VayuBlocksCssJustify,VayuBlocksCssTextAlign,
} from "@vayu-blocks/global";


export const getWrapperStyle = (attributes, view) => ({
	...(attributes.scroll && {
		maxHeight: attributes.scrollheight?.[view] || undefined,
		overflowY: 'auto',
		scrollBehavior: 'smooth',
	}),
});

export const getTitleGapStyle = (attributes, view) => ({
	marginBottom: attributes.spacing?.[view] || undefined,
	...VayuBlocksCssJustify(attributes.iconalignment, view),
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	background: attributes.titlebg,
	padding: dimensions(attributes.titlePadding, view),
	...borderStyle(attributes.titleBorder, view),
	...borderRadiusStyle(attributes.titleBorderRadius, view),
	...boxShadow(attributes.titleDropShadow, view),
	boxSizing: 'border-box',
});

export const getTitleTextStyle = (attributes, view) => ({
	color: attributes.titlecolor,
	...VayuBlocksTypography(attributes.titletypography, view),
});

export const getIconStyle = (attributes, view, openState, iconhovered) => ({
	background: iconhovered
		? attributes.iconbghvr || attributes.iconbg
		: attributes.iconbg,
	color: openState
		? (attributes.iconactivecolor || attributes.iconcolor)
		: iconhovered
			? attributes.iconcolorhvr || attributes.iconcolor
			: attributes.iconcolor,
	fill: openState
		? (attributes.iconactivecolor || attributes.iconcolor)
		: iconhovered
			? attributes.iconcolorhvr || attributes.iconcolor
			: attributes.iconcolor,
	padding: dimensions(attributes.iconPadding, view),
	...borderStyle(attributes.iconBorder, view),
	...borderRadiusStyle(attributes.iconBorderRadius, view),
	...boxShadow(attributes.iconDropShadow, view),
	boxSizing: 'border-box',
});

export const getContentStyle = (attributes, view) => ({
	background: attributes.contentbg,
	padding: dimensions(attributes.contentPadding, view),
	...borderStyle(attributes.contentBorder, view),
	...borderRadiusStyle(attributes.contentBorderRadius, view),
	...boxShadow(attributes.contentDropShadow, view),
	boxSizing: 'border-box',
	gap: attributes.contentspacing?.[view] || undefined,
	color: attributes.contentcolor,
	...VayuBlocksCssTextAlign(attributes.contentalignment, view),
	listStylePosition: 'inside',
});

export const getContentLiStyle = (attributes, view) => ({
	color: attributes.contentcolor,
	...VayuBlocksTypography(attributes.contenttypography, view),
});
